import  { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RoleandRightsAction } from '../actions/Roles/RoleandRightsAction'
import NotificationHandler from './NotificationHandler'
import { ServerRequestProtected } from './ServerDataRequest'
import { enumUtil } from './Enum'
import { SettingsActions } from '../actions/SettingsActions/SettingsActions'
import { GeneralDropDowns } from '../actions/GeneralPatientActions'
import { logIn, PracticeID } from '../actions/LoginAction'
import Cookies from "js-cookie";
import { isChildWindow } from './Constants'
import { CodesDropDown } from '../actions/CodesDropDown'
import { PaymentDropdown } from '../actions/PaymentDropdown'
import { Blinker } from '../actions/SettingsActions/BlinkerAction'
import { EncounterNotesDisplaySettings } from '../actions/EncounterNotesDisplaySettings';
import { NoteTypeDD } from '../actions/NoteType'
import useUserData from '../Components/hooks/useUserData'

const useLoadAppData = () => {
  let stateReduxLogin = useSelector(state => state.Login.token);
  const dispatch = useDispatch();
  const API_URL = enumUtil.controller.General;
  const API_URL_MenuOption = enumUtil.controller.MenuOption;
  const API_Dashboard = enumUtil.controller.Dashboard;
  const API_URL_PATIENT_ENCOUNTER = enumUtil.controller.PatientEncounter;
  const { handleLoadUserData } = useUserData();

  const LoadNoteSetting = (id) => {
    // console.log("LoadNoteSetting", id)
    // if (['-1', -1, 0, "", null, undefined].includes(id)) return;
    
    ServerRequestProtected(API_URL_PATIENT_ENCOUNTER + "/GetAllNoteTypeSetting", 'post', {
      "TableName": enumUtil.enumAPITableName.NoteTypeSetting,
      // "ID" : id ? String(id) : '',
    })
    .then((response) => {
      dispatch(EncounterNotesDisplaySettings(response?.Rows))
    }).catch((error) => {
    })
  }

  const handleLoadDD = () => {
    // setisLoading(true)
    ServerRequestProtected(API_URL + "/FillDropdowns", 'post', {
    }).then((response) => {
      //   setisLoading(false)
      let DisCardActiveIds = {
        ActiveClaimId: null,
        Patient: [],
        ActivePaymentId: null,
      }
      response = { ...response, DiscardIndicator: false, DisCardActiveIds: DisCardActiveIds, isRecordingStarted: false }
      dispatch(GeneralDropDowns(response))
      dispatch(PracticeID(response.Practice[0]?.PracticeID))
      // LoadNoteSetting();
    }).catch((error) => {
      //   setisLoading(false)
      NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
    })
    ServerRequestProtected(API_URL + "/RecentCodeSerch", 'post', {
      TableName: enumUtil.enumAPITableName.RECENTCODESERCH,
    }).then((response) => {
      dispatch(CodesDropDown(response))
    }).catch((error) => {
      NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
    })
  }

  const handleLoadPaymentsDD = () => {
    ServerRequestProtected(API_URL + "/FillDropdowns", 'post', {
      TableName : enumUtil.enumAPITableName.FILLDROPDOWNPAYMENTS,
    }).then((response) => {
      dispatch(PaymentDropdown(response))
    }).catch((error) => {
      NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
    })
  }

  const handleBlinker = () => {
    ServerRequestProtected(API_Dashboard + "/BillingItemBlinker", 'post', {
      TableName: enumUtil.enumAPITableName.BILLINGITEMBLINKER
    }).then((response) => {
    
      dispatch(Blinker({...response}))
    }).catch((error) => {
      NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
    })
  }


  const handleRolesAndRightsMenu = () => {
    //   setisLoading(true)
    ServerRequestProtected(API_URL_MenuOption + "/OnReloadFindMenuOption", 'post', {
      TableName: enumUtil.enumAPITableName.Roles
    }).then((response) => {
      dispatch(RoleandRightsAction(response))
      // setisLoading(false)
    }).catch((error) => {
      // setisLoading(false)
      NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
    })
  }

  const handleLoadSettingsGeneral = () => {
    // setisLoading(true)
    ServerRequestProtected("PracticesSetting/FindPracticeSetting", 'post', {
      TableName: enumUtil.enumAPITableName.General,
    }).then((response) => {
      // setisLoading(false)
      // to set multiple values in redux  use type:Settings and payload list of objects
      dispatch(SettingsActions({
        type: 'SettingsAll',
        payload: { ...response, PaginationDefaultRows: response.RowsPerPage, DefaultPageView: response.ViewType }
        // [...(response.RowsPerPage ? [{ type: 'PaginationDefaultRows', payload: response.RowsPerPage }] :
        //   [{ type: 'PaginationDefaultRows', payload: '10' }]),
        // ...(response.ViewType ? [{ type: 'DefaultPageView', payload: response.ViewType }] :
        //   [{ type: 'DefaultPageView', payload: 'Grid View' }]),]
      }));

      // dispatch(SettingsActions());
    }).catch((error) => {
      // setisLoading(false)
      // NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
    })
  }

  const handleLoadNoteTypes = () => {
    // setisLoading(true)
    ServerRequestProtected(API_URL + "/Dropdown", 'post', {
      TableName: enumUtil.enumAPITableName.NoteType
    }).then((response) => {
      dispatch(NoteTypeDD(response))
    }).catch((error) => {
      NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
    })
  }

  useEffect(() => {
    const cookieValue = Cookies.get('cookedToken');
    if (cookieValue) {
      dispatch(logIn({ token: cookieValue }))
    }
  }, []);

  useEffect(() => {
    if (stateReduxLogin) {
      if (isChildWindow) { Cookies.remove('reduxState'); return; }
      handleLoadDD();
      LoadNoteSetting();
      handleLoadPaymentsDD();
      handleBlinker()
      handleRolesAndRightsMenu();
      handleLoadSettingsGeneral();
      handleLoadNoteTypes();
      handleLoadUserData();
    }
  }, [stateReduxLogin])

  return null;
}

export default useLoadAppData